export const BADGES = [
  "badge-primary",
  "badge-secondary",
  "badge-success",
  "badge-danger",
  "badge-warning",
  "badge-info",
  "badge-light",
  "badge-dark",
];

export function removeAllParamsURL(url) {
  if (!url) {
    return "";
  }

  let _url;
  try {
    _url = new URL(url);
  } catch (err) {
    console.log("url = ", url);
    console.log(err);
    return "";
  }

  return _url.origin + _url.pathname;
}

export function getUrlVars(url) {
  const vars = [];
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    if (!vars.includes(value)) {
      vars.push(value);
    }
  });
  return vars;
}

export function convertToVagas(string) {
  return string.replace("byintera.in", "vagas-emb.byintera.com");
}

/**
 * Create new Status based on given URL. It must be in format https://vagas.byintera.com/{Company-LP-name}
 *
 * @param {String} url URL
 *
 */
export function getUrlStatus(url) {
  const exampleHostName = "vagas.byintera.com";
  const exampleFormat = `https://${exampleHostName}/nome-da-vaga`;

  const urlStatus = {
    valid: true,
    messages: [],
  };

  const setUrlInvalid = (errorMessage) => {
    urlStatus.valid = false;
    urlStatus.messages.push(errorMessage);
  };

  let _url;
  try {
    _url = new URL(url);
  } catch (error) {
    const messageOnInvalidURL = "Failed to construct 'URL': Invalid URL";

    if (error.message === messageOnInvalidURL) {
      setUrlInvalid("O link deve ser válido, como em " + exampleFormat);
    } else {
      console.log(error);
    }

    return urlStatus;
  }

  if (_url.pathname.slice(-1) === '/') {
    setUrlInvalid(
      "Retire a '/' do final do link. Links com uma barra no final não são permitidos."
    );
  }

  if (_url.protocol !== "https:") {
    setUrlInvalid("O seu link deve começar com 'https:'.");
  }

  if (_url.pathname.length === 1) {
    setUrlInvalid(
      `Você deve fornecer a página da empresa. Links como 'https://${exampleHostName}/' não são válidos.`
    );
  }

  if (_url.search.length || _url.href.includes("?")) {
    setUrlInvalid(
      "Apague tudo que vem depois da interrogação '?', incluindo a interrogação. O seu link já possui parâmetros na URL. "
    );
  }

  if (urlStatus.valid) {
    urlStatus.messages.push("O link está no formato correto.");
  }

  return urlStatus;
}

export function processLink(link) {
  if (!link) {
    return "";
  }

  const [newLink] = link.split("?");

  return newLink;
}
